<template>
<!-- banner -->
<div class="banner container-width">
  <swiper ref="bannerSwiper" :options="bannerSwiperOptions">

    <swiper-slide :class="{'mouse': item.jumpUrl}" v-for="item in list" :key="item.id">
      <img @click="jumpUrl(item)" :src="item.picUrl" width="100%" :alt="item.name">
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination">
      <span v-for="(item, index) in list" :key="item.id">{{index + 1}}</span>
    </div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  name: 'HomeBanner',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bannerSwiperOptions: {
        autoplay: true,
        loop: true,
        loopedSlides: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.bannerSwiper.$swiper
    }
  }
}
</script>
<style scoped>
.banner {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.banner img {
  height: 600px;
  object-fit: cover;
}
.banner .swiper-button-prev,
.banner .swiper-button-next {
  width: 35px;
  height: 45px;
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: center center;
  opacity: .8;
}

.banner .swiper-button-prev:hover,
.banner .swiper-button-next:hover {
  opacity: 0.4;
}
.banner .swiper-button-prev {
  /* left: calc((100vw - 1280px) / 2); */
  left: 40px;
  background-image: url(../../../assets/images/bn-left.png);
}
.banner .swiper-button-next {
  /* right: calc((100vw - 1280px) / 2); */
  right: 40px;
  background-image: url(../../../assets/images/bn-ri.png);
}

.swiper-pagination {
  bottom: 30px;
}
.swiper-pagination ::v-deep .swiper-pagination-bullet {
  width: 36px;
  height: 4px;
  border-radius: 3px;
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.5);
}
.swiper-pagination ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #fff;
  width: 80px;
}
.swiper-button-prev:after, .swiper-button-next:after {
  display: none;
}
@media screen and (max-width: 1000px) {
  .swiper-pagination ::v-deep .swiper-pagination-bullet {
    width: 25px;
  }
  .swiper-pagination ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 50px
  }
  .swiper-pagination {
    bottom: 20px;
  }
}
</style>
